import React from 'react';
import { DistanceSlider } from '@bwoty-web/styleguide';
import SliderWrapper from './SliderWrapper';
import Heading from './Heading';
import { ANALYTICS_DATA_TYPES } from '../../hooks/useAnalytics';
import { metroAnalyticsParams } from '../../utils/analytics';

const defaultProps = {
  prefix: '',
};

const FilterMetro = (props) => {
  const { label, heading, searchParams, refetchHotels } = props;

  const hidden = searchParams.filter === 'true';

  const { distanceMetroTo } = searchParams;

  const handleChangeComplete = (distance) => {
    refetchHotels({
      newSearchParams: {
        distanceMetroTo: distance === 10000 ? '' : distance.toString(),
      },
      analyticsData: {
        type: ANALYTICS_DATA_TYPES.FILTER,
        params: metroAnalyticsParams,
      },
    });
  };

  return (
    <div>
      {heading && <Heading>{heading}</Heading>}
      <SliderWrapper>
        <DistanceSlider
          onChangeComplete={handleChangeComplete}
          uniqueId="distance_center"
          value={parseInt(distanceMetroTo, 10) || DistanceSlider.maxValue}
          valueLabel={label || 'Up to'}
          hidden={hidden}
        />
      </SliderWrapper>
    </div>
  );
};

FilterMetro.defaultProps = defaultProps;

export default FilterMetro;
